import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceDirectCost} from './service-direct-cost.model';
import * as ServiceDirectCostActions from './service-direct-cost.actions';

export const serviceDirectCostsFeatureKey = 'serviceDirectCosts';

export interface State extends EntityState<ServiceDirectCost> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceDirectCost> = createEntityAdapter<ServiceDirectCost>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceDirectCostActions.addServiceDirectCost,
    (state, action) => adapter.addOne(action.serviceDirectCost, state)
  ),
  on(ServiceDirectCostActions.upsertServiceDirectCost,
    (state, action) => adapter.upsertOne(action.serviceDirectCost, state)
  ),
  on(ServiceDirectCostActions.addServiceDirectCosts,
    (state, action) => adapter.addMany(action.serviceDirectCosts, state)
  ),
  on(ServiceDirectCostActions.upsertServiceDirectCosts,
    (state, action) => adapter.upsertMany(action.serviceDirectCosts, state)
  ),
  on(ServiceDirectCostActions.updateServiceDirectCost,
    (state, action) => adapter.updateOne(action.serviceDirectCost, state)
  ),
  on(ServiceDirectCostActions.updateServiceDirectCosts,
    (state, action) => adapter.updateMany(action.serviceDirectCosts, state)
  ),
  on(ServiceDirectCostActions.deleteServiceDirectCost,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceDirectCostActions.deleteServiceDirectCosts,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceDirectCostActions.loadServiceDirectCosts,
    (state, action) => adapter.setAll(action.serviceDirectCosts, state)
  ),
  on(ServiceDirectCostActions.clearServiceDirectCosts,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
